module.exports = __webpack_public_path__ + "static/media/tool-primary.f342768e.svg";